

export class EmployeeFreebiesAssignRequest {
    employeeFreebiesId: number;
    employeeCode: string;
    freebieCode: string;
    username: string;
    freebieCount: number;
    year: number;
    month: number;
    maxConsumptionPerDay: number;
    isActive: boolean;

    employeeId?: number; // not required from the request object from the UI
    freebieId: number; // not required from the request object from the UI



    /**
     * 
     * @param employeeFreebieId 
     * @param employeeCode 
     * @param freebiesCode 
     * @param username 
     * @param freebiesCount 
     * @param year 
     * @param month 
     * @param maxConsumptionPerDay 
     * @param isActive
     * @param employeeId // not required from the request object from the UI
     * @param freebiesId // not required from the request object from the UI
     * 
     */
    constructor(employeeFreebieId: number,employeeCode: string,freebieCode: string,username: string,freebieCount: number,year: number,month: number,maxConsumptionPerDay: number,isActive:boolean, employeeId?: number, freebieId?: number) {
        this.employeeFreebiesId = employeeFreebieId;
        this.employeeCode = employeeCode;
        this.freebieCode = freebieCode;
        this.username = username;
        this.freebieCount = freebieCount;
        this.year = year;
        this.month = month;
        this.maxConsumptionPerDay = maxConsumptionPerDay;
        this.isActive = isActive;
        this.employeeId = employeeId;
        this.freebieId = freebieId;
    }
}


